import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1508083535939-45a5fa9f0226?fm=jpg&q=80&w=1400&auto=format&fit=crop";

const Home = () => {
  return (
    <div data-testid="home-page">
      {/* Hero */}
      <section
        className="relative overflow-hidden"
        style={{ backgroundColor: "var(--mc-bg)" }}
        data-testid="hero-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-20 md:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-7 mc-fade-in">
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-8"
              style={{ color: "var(--mc-muted)" }}
              data-testid="hero-eyebrow"
            >
              Online and In-Person Counselling &amp; Therapy
            </p>
            <h1
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight"
              style={{ color: "var(--mc-ink)" }}
              data-testid="hero-heading"
            >
              Counselling for{" "}
              <em style={{ color: "var(--mc-ink-2)" }}>emotional wellbeing</em>
              {" "}&amp; meaningful personal growth.
            </h1>
            <p
              className="mt-8 md:mt-10 text-lg md:text-xl leading-relaxed max-w-xl font-light"
              style={{ color: "var(--mc-ink-2)" }}
              data-testid="hero-subhead"
            >
              My aim is to provide a safe, supportive space where you can
              better understand yourself, navigate life’s challenges, and move
              towards lasting positive change.
            </p>
          </div>

          <div className="lg:col-span-5 mc-fade-in mc-delay-2">
            <div
              className="relative aspect-[4/5] w-full overflow-hidden rounded-[2rem]"
              style={{ backgroundColor: "var(--mc-bg-3)" }}
              data-testid="hero-image-wrap"
            >
              <img
                src={HERO_IMG}
                alt="Silky stream flowing over moss-covered rocks"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(39,50,40,0.05) 0%, rgba(39,50,40,0.25) 100%)",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Closing CTA — "Begin where you are" (moved above quote) */}
      <section
        className="border-t"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg-2)",
        }}
        data-testid="home-closing-cta"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <h2
            className="font-serif-display text-3xl md:text-5xl leading-tight max-w-md"
            style={{ color: "var(--mc-ink)" }}
          >
            Counselling begins with connection.
          </h2>
          <div className="md:justify-self-end max-w-md">
            <p
              className="text-base md:text-lg leading-relaxed mb-8 font-light"
              style={{ color: "var(--mc-ink-2)" }}
            >
              Before committing to sessions, we can have a complimentary
              15-minute conversation to explore what you’re looking for, answer
              any questions, and see whether working together feels like the
              right fit.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-sm tracking-wide transition-colors duration-300"
              style={{ backgroundColor: "var(--mc-ink)", color: "var(--mc-bg)" }}
              data-testid="home-contact-cta"
            >
              Start the Conversation
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* Quote — Lao Tzu (now below the CTA) */}
      <section
        className="relative border-t"
        style={{
          backgroundColor: "var(--mc-bg)",
          borderColor: "rgba(201, 192, 171, 0.55)",
        }}
        data-testid="quote-section"
      >
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
          <p
            className="font-serif-display italic text-3xl md:text-5xl lg:text-6xl leading-[1.25] max-w-4xl mx-auto"
            style={{ color: "var(--mc-ink)" }}
            data-testid="lao-tzu-quote"
          >
            “Simplicity, patience, compassion.
            <br className="hidden md:block" /> These three are your greatest
            treasures.”
          </p>
          <p
            className="mt-10 text-sm md:text-base tracking-eyebrow uppercase"
            style={{ color: "var(--mc-muted)" }}
          >
            — Lao Tzu, trans. Stephen Mitchell
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
